/* tatvamazi v1.7.0: add to cart without leaving the page, filter chips, quantity steppers, product thumbnails. No libraries. */
(() => {
  const $ = (id) => document.getElementById(id);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  let tId;
  const toast = (msg, link) => {
    const t = $("toast"); if (!t) return;
    t.textContent = msg;
    if (link) { const a = document.createElement("a"); a.href = root + "cart"; a.textContent = link; t.append(a); }
    t.classList.add("show"); clearTimeout(tId); tId = setTimeout(() => t.classList.remove("show"), 3000);
  };

  const copy = $("copyMail");
  if (copy) copy.onclick = () => {
    const el = $("mail");
    try { navigator.clipboard.writeText(el.textContent).then(() => toast("Email copied")); } catch (e) { /* the address stays visible */ }
  };

  // Quantity steppers. In the cart a change updates the cart straight away.
  document.querySelectorAll("[data-qty]").forEach((q) => {
    const input = q.querySelector("input");
    q.querySelectorAll("[data-step]").forEach((b) => b.addEventListener("click", () => {
      const min = input.hasAttribute("data-autosubmit") ? 0 : 1;
      input.value = Math.min(20, Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.step, 10)));
      if (input.hasAttribute("data-autosubmit")) { const f = input.form, u = f.querySelector("[name=update]"); f.requestSubmit ? f.requestSubmit(u) : f.submit(); }
    }));
  });

  // Add to cart in place. "Buy now" (name=return_to) posts normally and goes straight to checkout.
  // Without JavaScript every form still posts to /cart/add and lands on the cart.
  const setCount = (n) => document.querySelectorAll("[data-cart-count]").forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  document.querySelectorAll("form.js-add").forEach((form) => form.addEventListener("submit", async (e) => {
    if (e.submitter && e.submitter.name === "return_to") return;
    e.preventDefault();
    const btn = e.submitter || form.querySelector("[type=submit]");
    const label = btn ? btn.textContent : "";
    if (btn) { btn.disabled = true; btn.textContent = "Adding…"; }
    try {
      const res = await fetch(root + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) });
      if (!res.ok) { const err = await res.json().catch(() => ({})); throw new Error(err.description || "Could not add to cart"); }
      const cart = await (await fetch(root + "cart.js")).json();
      setCount(cart.item_count);
      toast("Added to cart", "View cart");
      if (btn) btn.textContent = "Added ✓";
      setTimeout(() => { if (btn) { btn.textContent = label; btn.disabled = false; } }, 1400);
    } catch (err) {
      toast(err.message || "Could not add to cart");
      if (btn) { btn.textContent = label; btn.disabled = false; }
    }
  }));

  // Home filter chips (All / Cooking oil / Hair oils). The header "Hair oils" link and #hair open the filtered list.
  const chips = document.querySelectorAll("[data-filter]");
  const applyFilter = (f) => {
    chips.forEach((b) => { const on = b.dataset.filter === f; b.classList.toggle("is-on", on); b.setAttribute("aria-selected", on); });
    document.querySelectorAll(".home .card").forEach((c) => { c.hidden = f !== "all" && c.dataset.kind !== f; });
  };
  chips.forEach((b) => b.addEventListener("click", () => applyFilter(b.dataset.filter)));
  if (chips.length) {
    document.querySelectorAll("[data-go-filter]").forEach((a) => a.addEventListener("click", (e) => {
      e.preventDefault(); applyFilter(a.dataset.goFilter); const m = a.closest("details"); if (m) m.open = false; $("shop").scrollIntoView();
    }));
    if (location.hash === "#hair") { applyFilter("hair"); $("shop").scrollIntoView(); }
  }

  // Phones: the bottom "Add to cart" bar shows only while the main button is off screen, so there is never two at once
  const bar = document.querySelector(".buybar"), buyForm = $("buyForm");
  if (bar && buyForm && "IntersectionObserver" in window) new IntersectionObserver(([en]) => bar.classList.toggle("is-on", !en.isIntersecting)).observe(buyForm);
  else if (bar) bar.classList.add("is-on");

  // Product thumbnails
  const main = $("gMain");
  if (main) document.querySelectorAll(".thumb").forEach((t) => t.addEventListener("click", () => {
    const img = main.querySelector("img");
    if (img) { img.removeAttribute("srcset"); img.src = t.dataset.src; }
    document.querySelectorAll(".thumb").forEach((x) => x.classList.toggle("is-on", x === t));
  }));
})();
